import { css } from 'styled-components';
import token from 'styled-token';
import { StyledAnchor } from '../../components/Anchor/Anchor.styles';
import { StyledUnstyledButton } from '../../components/UnstyledButton/UnstyledButton.styles';
import { disabledCursorMixin } from '../disabledCursorMixin';
import { disabledMixin } from '../disabledMixin';
import { hoverMediaQueryMixin } from '../hoverMediaQueryMixin';
import { typographyMixin } from '../typographyMixin';
var AnchorButtonCSS = function AnchorButtonCSS(props) {
  return token({
    borderWidth: 'VerticalNavItem.borderWidth',
    fontColor: 'VerticalNavItem.fontColor',
    fontType: 'VerticalNavItem.fontType',
    horizontalSpacing: 'VerticalNavItem.horizontalSpacing',
    verticalSpacing: 'VerticalNavItem.verticalSpacing'
  }, function (_ref) {
    var borderWidth = _ref.borderWidth,
      fontColor = _ref.fontColor,
      fontType = _ref.fontType,
      horizontalSpacing = _ref.horizontalSpacing,
      verticalSpacing = _ref.verticalSpacing;
    return css(["", " display:block;text-decoration:none;padding:", "px ", "px ", "px ", "px;&,&:focus{color:", ";}&:visited{color:", ";}", ";&:active{color:", ";}"], typographyMixin(Object.assign({
      fontType: fontType,
      fontTypeIconAlignment: false
    }, props)), verticalSpacing, horizontalSpacing, verticalSpacing, horizontalSpacing - borderWidth, fontColor, fontColor, hoverMediaQueryMixin("color: " + fontColor + ";"), fontColor);
  })(props);
};
var activeCSS = function activeCSS(props) {
  return token({
    backgroundColorActive: 'VerticalNavItem.backgroundColorActive',
    fontWeightActive: 'VerticalNavItem.fontWeightActive',
    borderColorActive: 'VerticalNavItem.borderColorActive'
  }, function (_ref2) {
    var backgroundColorActive = _ref2.backgroundColorActive,
      borderColorActive = _ref2.borderColorActive,
      fontWeightActive = _ref2.fontWeightActive;
    return css(["background-color:", ";border-color:", ";", "{font-weight:", ";}", "{font-weight:", ";}"], backgroundColorActive, borderColorActive, StyledAnchor, fontWeightActive, StyledUnstyledButton, fontWeightActive);
  })(props);
};

/** @class VerticalNavItemMixin */
/** @method */
export var VerticalNavItemMixin = function VerticalNavItemMixin(props) {
  return token({
    backgroundColor: 'VerticalNavItem.backgroundColor',
    backgroundColorHover: 'VerticalNavItem.backgroundColorHover',
    borderColor: 'VerticalNavItem.borderColor',
    borderRadius: 'VerticalNavItem.borderRadius',
    borderWidth: 'VerticalNavItem.borderWidth'
  }, function (_ref3) {
    var backgroundColor = _ref3.backgroundColor,
      backgroundColorHover = _ref3.backgroundColorHover,
      borderColor = _ref3.borderColor,
      borderRadius = _ref3.borderRadius,
      borderWidth = _ref3.borderWidth;
    return css(["background-color:", ";border-style:solid;border-width:0 0 0 ", "px;border-color:", ";box-sizing:border-box;cursor:pointer;display:block;width:100%;outline:none;text-align:left;border-top-right-radius:", "px;border-bottom-right-radius:", "px;&::-moz-focus-inner{border:0;}@media (hover:hover) and (pointer:fine){&:hover:not([aria-disabled='true']){background-color:", ";border-color:", ";}&[aria-disabled='true'] *{", "}}&:focus:not([aria-disabled='true']),&:active:not([aria-disabled='true']){background-color:", ";}&[aria-disabled]{", " > a{pointer-events:none;}}", "{", "}", "{width:100%;", "}&[aria-current]:not([aria-current='false']){", "}&[aria-selected='true']{", "}"], backgroundColor, borderWidth, borderColor, borderRadius, borderRadius, backgroundColorHover, borderColor, disabledCursorMixin({
      disabled: true
    }), backgroundColorHover, disabledMixin(Object.assign({}, props, {
      disabled: true
    })), StyledAnchor, AnchorButtonCSS(props), StyledUnstyledButton, AnchorButtonCSS(props), activeCSS(props), activeCSS(props));
  })(props);
};